<template>
  <div class="container">
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1 class="title is-size-4-mobile">
            {{ $t("Screens") }} ({{ screens }})
          </h1>
        </div>
      </div>
      <div v-if="isAdmin" class="level-right">
        <div class="level-item">
          <a class="button is-primary is-outlined" @click="addScreen">
            <span class="icon is-small"><i class="fa fa-plus"></i></span>
            <span>{{ $t("Add screen") }}</span>
          </a>
        </div>
        <div class="level-item">
          <a
            class="button is-danger is-outlined"
            :disabled="screens <= 0"
            @click="openRemoveScreen"
          >
            <span class="icon is-small"><i class="fa fa-minus"></i></span>
            <span>{{ $t("Remove screen") }}</span>
          </a>
        </div>
      </div>
    </nav>

    <div class="columns is-multiline is-mobile">
      <div
        class="column screens-grid is-full-mobile is-half-tablet is-half-desktop is-one-third-widescreen is-one-third-fullhd"
        v-for="(screenDevices, screenId) of screensDevices"
        :key="screenId"
      >
        <div class="screen-preview-item">
          <a
            :href="`/#/projects/${projectId}/screen/${screenId}`"
            target="_blank"
          >
            <span class="icon"><i class="fa fa-tv"/></span>
            <span>{{ $t("Screen {0}", Number(screenId) + 1) }}</span>
          </a>
          <screen-preview class="screen-preview-image" :screenId="screenId" />
          <multiselect-field
            :value="screenDevices"
            :disabled="!isAdmin"
            @change="changeScreenDevice(screenId, $event)"
          />
        </div>
      </div>
    </div>

    <modal-confirmation
      :is-open.sync="deletingScreen"
      :title="$t('Are you sure you want to delete this screen?')"
      :confirmText="$t('Delete')"
      @confirm="removeScreen"
    >
      {{
        $t(
          "Once screen {0} is deleted, you will not be able to recover it!",
          screens
        )
      }}
    </modal-confirmation>
  </div>
</template>

<script>
import { state, actions } from "@/store"
import { ScreenPreview } from "@/components/screen"
import { ModalConfirmation } from "@/components/modal"
import { MultiselectField } from "@/components/form"

export default {
  name: "screens",
  props: ["projectId"],
  components: {
    ScreenPreview,
    ModalConfirmation,
    MultiselectField
  },
  data() {
    return {
      deletingScreen: false
    }
  },
  computed: {
    devices() {
      return Object.values(state.project.devices)
    },
    screens() {
      return state.project.data.screens
    },
    screensDevices() {
      const screensDevices = {}
      for (let i = 0; i < this.screens; i++) {
        screensDevices[i] = this.devices.map(device => ({
          value: device.id,
          text: device.name,
          selected: device.screenId === i
        }))
      }
      return screensDevices
    },
    isAdmin() {
      return state.isAdmin
    }
  },
  methods: {
    addScreen() {
      actions.clearErrors()
      actions.addScreen().catch(actions.addError("add-screen-error"))
    },
    openRemoveScreen() {
      actions.clearErrors()
      this.deletingScreen = true
    },
    removeScreen() {
      const screenId = this.screens - 1
      this.cancelRemoveScreen()
      actions
        .removeScreen()
        .then(() => actions.removeScreenFromAllDevices(screenId))
        .catch(actions.addError("remove-screen-error"))
    },
    cancelRemoveScreen() {
      this.deletingScreen = false
    },
    changeScreenDevice(screenId, changed) {
      actions.clearErrors()
      screenId = Number(screenId)
      if (changed.selected) {
        actions
          .addScreenToDevice(changed.value, screenId)
          .catch(actions.addError("add-screen-error"))
      } else {
        actions
          .removeScreenFromDevice(changed.value, screenId)
          .catch(actions.addError("remove-screen-error"))
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";

.screen-preview-item {
  border: 1px solid $item-border-color;
  border-radius: 4px;
  padding: 0.25em;
}
.screen-preview-image {
  margin-top: 0.25em;
  margin-bottom: 0.25em;
}

@include mobile {
  .level {
    .level-item {
      align-items: left;
      justify-content: left;
    }
  }
}
</style>
